import { Divider, Flex, Input, Text } from "@fluentui/react-northstar";
import styled, { css } from "styled-components";

export const Email = styled(Text)`
    color: #000;

    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;
export const EmailLabel = styled(Text)`
    color: #000;

    /* Medium/400 */
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;
export const OTPLabel = styled(Text)`
    color: #000;

    /* Large/400 */
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 133.333% */
`;
export const InputContainer = styled(Flex)`
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    /* margin-bottom: 2rem; */
`;
export const OTPInput = styled.input`
    text-align: center;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
    outline: none;
    transition: all 0.2s;

    width: 2rem;
    max-width: 2rem !important;
    height: 2.5rem;
    border-radius: var(--radius-m-4, 4px);

    ${({ $error }) =>
        $error
            ? css`
                  border: 1px solid
                      var(--Light-theme-Rest-Border-Red-Border, #f3d6d8);
                  background: var(
                      --Light-theme-Rest-Background-Red-Background-1,
                      #fcf4f6
                  );
              `
            : css`
                  background: var(
                      --Light-theme-Rest-Background-Default-Background-2,
                      #f5f5f5
                  );
                  border: 1px solid
                      var(--Light-theme-Rest-Border-Default-Border-3, #f0f0f0);
              `}

    &:focus {
        border-color: var(--color-primary);
        box-shadow: 0 0 0 3px rgba(91, 95, 199, 0.2);
    }
`;
export const DividerStyle = styled(Divider)`
    width: 16px;
    height: 1px;
`;
export const WrapperDividerStyle = styled(Flex)`
    padding-right: 20px;
    padding-left: calc(24px + 0.5rem);
`;
export const OTPRegeneration = styled(Flex)`
    width: 260px;
`;
export const ErrorOTP = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Red-Foreground, #c4314b);

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;
